<template>
  <div class="booking-form mx-4 col-lg-6 col-md-8 col-sm-10">
    <b-form-group class="form-group_center" label="Booking confirmation emails" label-cols="4" label-cols-sm="8">
      <b-form-checkbox
        v-model="settings.booking_confirmation_enabled"
        :disabled="saving || !canControl"
        @change="saveSetting('booking_confirmation_enabled')"
      />
    </b-form-group>
    <b-form-group
      v-if="settings.booking_confirmation_enabled"
      label="Hours before booking to send confirmation"
      label-cols="4"
      label-cols-sm="8"
      :state="!serverErrors.booking_confirmation_hours_before"
      description="Token links are valid for 24 hours"
    >
      <b-form-input
        type="number"
        min="1"
        max="168"
        v-model.number="settings.booking_confirmation_hours_before"
        :disabled="saving || !canControl"
        @blur="saveSetting('booking_confirmation_hours_before')"
      />
      <template #invalid-feedback>
        <div v-if="serverErrors.booking_confirmation_hours_before">{{ getServerFieldErrors('booking_confirmation_hours_before') }}</div>
      </template>
    </b-form-group>

    <hr>

    <p class="text-muted">
      Automatically release desk bookings that go unconfirmed, so they become available to other employees.
      Requires <strong>Booking confirmation emails</strong> to be enabled above.
    </p>

    <b-form-group class="form-group_center" label="Enable auto-delete" label-cols="4" label-cols-sm="8">
      <b-form-checkbox
        v-model="settings.booking_autodelete_enabled"
        :disabled="saving || !canControl || !settings.booking_confirmation_enabled"
        @change="saveSetting('booking_autodelete_enabled')"
      />
    </b-form-group>

    <p v-if="!settings.booking_confirmation_enabled" class="text-warning">
      Enable booking confirmation emails above first.
    </p>
    <div v-if="serverErrors.booking_autodelete_enabled" class="text-danger">
      {{ getServerFieldErrors('booking_autodelete_enabled') }}
    </div>

    <b-form-group
      v-if="settings.booking_autodelete_enabled && settings.booking_confirmation_enabled"
      label="Auto-delete timeout (hours after confirmation email is sent)"
      label-cols="4"
      label-cols-sm="8"
      :state="!serverErrors.booking_autodelete_hours"
      :description="`Must leave at least 1 hour before the confirmation notice period (currently ${settings.booking_confirmation_hours_before} hours).`"
    >
      <b-form-input
        type="number"
        min="1"
        max="168"
        v-model.number="settings.booking_autodelete_hours"
        :disabled="saving || !canControl || !settings.booking_confirmation_enabled"
        @blur="saveSetting('booking_autodelete_hours')"
      />
      <template #invalid-feedback>
        <div v-if="serverErrors.booking_autodelete_hours">{{ getServerFieldErrors('booking_autodelete_hours') }}</div>
      </template>
    </b-form-group>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'Booking',
  data: () => ({
    saving: false,
    serverErrors: {},
  }),
  computed: {
    ...mapState('settings', ['bookingSettings']),
    ...mapGetters('settings', ['canControl']),
    settings: {
      get() { return this.bookingSettings },
      set(settings) { this.setBookingSettings(settings) }
    }
  },
  created() {
    this.loadBookingSettings()
  },
  methods: {
    ...mapMutations('settings', ['setBookingSettings']),
    ...mapActions('settings', ['loadBookingSettings', 'saveBookingSettings']),
    getServerFieldErrors(fieldName) {
      return this.serverErrors[fieldName]?.join(', ') ?? ''
    },
    async saveSetting(field) {
      this.serverErrors = {}
      try {
        this.saving = true
        await this.saveBookingSettings({ [field]: this.settings[field] })
      } catch (e) {
        if (e.response?.status === 422) {
          this.$set(this, 'serverErrors', e.response.data.errors)
        } else {
          await this.loadBookingSettings()
        }
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
